import { render, staticRenderFns } from "./BirthdaysOverview.vue?vue&type=template&id=8608d412&scoped=true&"
import script from "./BirthdaysOverview.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8608d412",
  null
  
)

export default component.exports